import { put, select } from 'redux-saga/effects';

// Helpers
import { payInstallment } from '../../../lib/api-helper';

// Getters
import {
  paymentPlanId
} from '../../payment-plans/getters';

// Constants
import {
  UPDATE_CREDIT_CARD_SUCCESS,
  UPDATE_CREDIT_CARD_ERROR
} from '../actions';

import {
  ADD_FLASH_MESSAGE
} from '../../my-tickets/actions';

export function* updateCreditCard({ payload }) {
  try {
    const installmentId = yield select(paymentPlanId);
    const res = yield payInstallment(installmentId, payload.token.id);
    if (res && res.errors) {
      yield put({ type: UPDATE_CREDIT_CARD_ERROR, payload: res.errors });
      yield put({ type: ADD_FLASH_MESSAGE, payload: { level: 'danger', message: 'updateCreditCardDeclinedError' }});
    }
    else {
      yield put({ type: UPDATE_CREDIT_CARD_SUCCESS, payload: res });
      yield put({ type: ADD_FLASH_MESSAGE, payload: { level: 'success', message: 'updateCreditCardSuccess' }});
    }
  }
  catch (e) {
    yield put({ type: UPDATE_CREDIT_CARD_ERROR, e });
    yield put({ type: ADD_FLASH_MESSAGE, payload: { level: 'danger', message: 'updateCreditCardError' }});
  }
}



// WEBPACK FOOTER //
// ./src/modules/stripe/actions/sagas.js